import { environmentFromHost, isQAEnviroment } from 'shared/environment-helpers'
import { isBrazilNeo } from './country'

const environment = environmentFromHost()

const dev = __DEV__
const ca = environment === 'ca'
const be = environment === 'be'
const lu = environment === 'lu'
const es = environment === 'es'
const uk = environment === 'uk'

const countryPurchaseFlow = window.COUNTRY_PURCHASE_FLOW?.toLowerCase()

const isCanadaPurchaseFlow = countryPurchaseFlow === 'ca'
const isBrazilNeoPurchaseFlow = window.COUNTRY?.toLowerCase() === 'br-neo'
const hasDownloadApp = window.SHOW_DOWNLOAD_APP
const isColumbia = window.COUNTRY?.toLowerCase() === 'co'

const qa = isQAEnviroment()

const featureToggles = {
    // business logic
    showCookiePolicy: !!window.SHOW_COOKIE_POLICY,

    // Auth
    newAuthFlow: !!window.USE_THINX_API,
    additionalSignupData: isBrazilNeoPurchaseFlow || isColumbia,
    confirmSignUpEmail: dev || uk || qa || be || lu || es || false,
    requiresPhoneNumberDuringSignUp: isBrazilNeo,

    // Map
    canFilterByVehicleTypes: !isBrazilNeo,

    // Buying
    newSubscriptionFlow: isCanadaPurchaseFlow || isBrazilNeoPurchaseFlow || isColumbia,

    bookingRedirect: isBrazilNeo,

    // if we remove canada subscription flow code, following line will be removed as well
    caPurchaseFlow: isCanadaPurchaseFlow,
    brNeoPurchaseFlow: isBrazilNeoPurchaseFlow,
    newSubscriptionDashboard: isCanadaPurchaseFlow,
    nifRequired: es || false,
    hasPrepaidFlow: !!window.HAS_PREPAID_FLOW,
    supportsDebitCard: !isBrazilNeo,
    hasEventFlow: window.HAS_EVENT_FLOW === 'true' || false,
    hasAirportFlow: window.HAS_AIRPORT_FLOW === 'true' || false,
    isRenewSubscriptionAlways: isBrazilNeo,
    showAllExceptCanada: !ca,
    hasUpSellFlow: window.HAS_UPSELL_FLOW === 'true' || false,
    has3dsPayment: window.HAS_3DS_PAYMENT === 'true' || false,

    // dev tools
    hasHotModuleReplacement: dev || false,
    hasReduxDevTools: dev || qa || false,

    // general
    hasRentalCarFlow: window.HAS_RENTAL_CAR_FLOW === 'true',
    hasOnDemandParking: window.HAS_ON_DEMAND_PARKING === 'true',
    hasBusinessUser: window.SHOW_BUSINESS,
    hasSubscriptionTab: window.SHOW_MONTHLY,
    hasReminders: isBrazilNeo,
    showDownloadApp: hasDownloadApp,
    hasSubcriptionLite: isCanadaPurchaseFlow,
    hasTermAndConditionsNewFlow: window.HAS_NEW_TERMS_COND_FLOW === 'true',
    showNpsSurvey: window.SHOW_NPS_SURVEY === 'true',
    showFlightInfo: window.SHOW_FLIGHT_INFO === 'true',
    hasAdditionalProducts: window.ADDITIONAL_PRODUCTS === 'true',
    hasPIXPurchase: isBrazilNeo && window.HAS_PIX_PURCHASE === 'true',
    hasPsePurchase: window.HAS_PSE_PURCHASE === 'true',
    hasGuestCheckoutFlow: window.GUEST_CHECKOT_FLOW === 'true',
    showSoldOutProducts: window.SHOW_SOLD_OUT_PRODUCTS === 'true',
    showOnScreenCookieButton: window.HAS_COOKIE_BUTTON === 'true' && window.SHOW_COOKIE_POLICY === 'true',
    enableEditBooking: window.ENABLE_EDIT_BOOKING === 'true',
    displayNonBookableLocationsPrice: window.DISPLAY_NON_BOOKABLE_LOCATIONS_PRICE === 'true',
    showCreditCardAddedPopup: window.SHOW_CREDIT_CARD_ADDED_POPUP === 'true',
    accountActivationRequired: isCanadaPurchaseFlow || isBrazilNeoPurchaseFlow,
    isColumbia,
    showBookingRestrictions: window.ENABLE_BOOKING_RESTRICTION_POPUP === 'true',
    hidePriceBreakdown: window.DISABLE_BOOKING_PRICE_BREAKDOWN === 'true',
    hasGooglePayEnabled: window.HAS_GOOGLE_PAY_ENABLED === 'true',
    hasBMOPromo: window.HAS_BMO_PROMO === 'true',
}

export default featureToggles
